import React from 'react';
import logo2 from "../utils/images/logo2.png";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
    const phoneNumber = '7842943189';

    return (
        <footer className="bg-gradient-to-b from-gray-900 to-gray-800 text-white py-8">
            <div className="container mx-auto px-4 flex flex-wrap justify-between">
                {/* Logo Section */}
                <div className="flex items-center justify-center mb-5 mr-20">
                    <img src={logo2} alt="Logo" className="h-10 mr-2" />
                    <span className="text-lg items-center font-bold text-white-900">मेरा समाज</span>
                </div>

                {/* Quick Links Section */}
                <div className="w-full md:w-1/4 mb-6">
                    <h2 className="text-lg font-semibold mb-2">Quick Links</h2>
                    <ul>
                        <li className="flex items-center mb-2">
                            <a
                                href={`https://wa.me/${phoneNumber}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center hover:underline"
                            >
                                <WhatsAppIcon className="mr-2 text-green-500" />
                                <span>WhatsApp</span>
                            </a>
                        </li>
                        <li className="flex items-center">
                            <a
                                href="https://in.linkedin.com/company/codebasera"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center hover:underline"
                            >
                                <LinkedInIcon className="mr-2 text-blue-300" />
                                <span>LinkedIn</span>
                            </a>
                        </li>
                    </ul>
                </div>

                {/* Policies Section */}
                <div className="w-full md:w-1/4 mb-6">
                    <h2 className="text-lg font-semibold mb-2">Policies</h2>
                    <ul>
                        <li className="mb-2">
                            <a
                                href="/privacyPolicy"
                                className="hover:underline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Privacy Policy
                            </a>
                        </li>
                        <li className="mb-2">
                            <a
                                href="/refundPolicy"
                                className="hover:underline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Refund Policy
                            </a>
                        </li>
                        <li>
                            <a
                                href="/termsAndCondition"
                                className="hover:underline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Terms & Conditions
                            </a>
                        </li>
                    </ul>
                </div>

                {/* Contact Section */}
                <div className="w-full md:w-1/4 mb-6">
                    <h2 className="text-lg font-semibold mb-2">संपर्क करें</h2>
                    <p className="mb-2">Office Location</p>
                    <p className="text-sm mb-4">N 302, Vivek Vihar Yojna, Sangariya, Jodhpur, Rajasthan, India</p>
                    <p className="mb-2">Email Address</p>
                    <p className="text-sm">contact@codebasera.com</p>
                </div>

                {/* Copyright Section */}
                <div className="w-full text-center mt-6 border-t border-white pt-4">
                    <p className="text-sm">
                        © Copyright CodeBasera Technologies. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
